import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDD1Glqtd3PFmI9yudAxSwFIToOVXnv-LE",
  authDomain: "thecakeslounge-1d3de.firebaseapp.com",
  projectId: "thecakeslounge-1d3de",
  storageBucket: "thecakeslounge-1d3de.firebasestorage.app",
  messagingSenderId: "449076668140",
  appId: "1:449076668140:web:c81fa1b7058315715567c9",
  measurementId: "G-6B7FZXNFM8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };